
import { Dialog, DialogContent, DialogTitle, DialogHeader, DialogClose } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X as XIcon, Instagram, MessageCircle } from "lucide-react";

interface VetoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSocialMediaClick: (platform: 'tiktok' | 'instagram' | 'twitter') => void;
}

export function VetoDialog({ open, onOpenChange, onSocialMediaClick }: VetoDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-bold">Use your Veto!</DialogTitle>
        </DialogHeader>
        <DialogClose className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
          <XIcon className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </DialogClose>
        <div className="flex flex-col items-center gap-4 py-2">
          <Button 
            className="w-full bg-[#ea384c] hover:bg-[#d41d32] text-white gap-2"
            onClick={() => window.open("https://www.tiktok.com/@matchmylogic", "_blank")}
          >
            <MessageCircle size={20} />
            Veto on TikTok
          </Button>
          
          <Button 
            className="w-full bg-[#c13584] hover:bg-[#a62f74] text-white gap-2"
            onClick={() => window.open("https://www.instagram.com/matchmylogic", "_blank")}
          >
            <Instagram size={20} />
            Veto on Instagram
          </Button>
          
          <Button 
            className="w-full bg-black hover:bg-gray-800 text-white gap-2"
            onClick={() => onSocialMediaClick('twitter')}
          >
            <XIcon size={20} />
            Veto on X
          </Button>
          
          <p className="text-gray-500 text-sm mt-2">#matchmylogic</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
